import {
  updateResourceState,
  normalizeResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD
} from 'react-structure-admin';
import {
  ACCOUNT,
  ACCOUNT_SHARING_GET,
  ACCOUNT_SHARING_GET_FINISHED,
  ACCOUNT_ACTIVITY_FETCH,
  ACCOUNT_ACTIVITY_FETCH_FINISHED,
  ACCOUNT_SHARING_UNLOAD,
  ACCOUNT_SHARING_GET_ERROR,
  ACCOUNT_SETTINGS_GET,
  ACCOUNT_SETTINGS_GET_FINISHED,
  ACCOUNT_SETTINGS_UPDATE,
  ACCOUNT_SETTINGS_UPDATE_FINISHED,
  ACCOUNT_CANCEL,
  ACCOUNT_CANCEL_FINISHED
} from './accountActions';

const accountReducer = createResourceReducer(
  ACCOUNT,
  [],
  {
    [ACCOUNT_SHARING_UNLOAD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        activities: {}
      }));
    },

    [ACCOUNT_SHARING_GET](state, action) {
      const newState = normalizeResourceState(state, action.resource);

      return updateResourceState(newState, action, RESOURCE, () => ({
        activities: { [RECORD_FIELD]: {}, loading: true, errorMessage: null }
      }));
    },

    [ACCOUNT_SHARING_GET_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => ({
        activities: {
          [RECORD_FIELD]: action.payload.data.result,
          loading: false
        }
      }));
    },

    [ACCOUNT_ACTIVITY_FETCH](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        fetching: true
      }));
    },

    [ACCOUNT_ACTIVITY_FETCH_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => {
        const { items = [] } = resource.activities;
        return {
          activities: {
            ...resource.activities,
            pagination: {
              ...resource.activities.pagination,
              total: action.payload.data.result.totalCount,
              current: Number(action.payload.config.params.page) || 1
            },
            totalCount: action.payload.data.result.totalCount,
            items: [...items, ...action.payload.data.result.items],
            queryParams: action.payload.config.params,
            editing: action.payload.config.params.act === 'editing',
            loaded: true,
            fetching: false
          }
        };
      });
    },

    [ACCOUNT_SHARING_GET_ERROR](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => ({
        activities: {
          ...resource.activities,
          loading: false,
          errorMessage: action.payload.message
        }
      }));
    },
    [ACCOUNT_SETTINGS_GET](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(newState, action, RESOURCE, () => ({
        settings: {
          loading: true
        }
      }));
    },

    [ACCOUNT_SETTINGS_GET_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        settings: { [RECORD_FIELD]: action.payload.data.result, loading: false }
      }));
    },
    [ACCOUNT_SETTINGS_UPDATE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        settings: { [RECORD_FIELD]: action.payload, saving: true }
      }));
    },

    [ACCOUNT_SETTINGS_UPDATE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => ({
        settings: { saving: false }
      }));
    },

    [ACCOUNT_CANCEL_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, (resource) => ({
        loaded: false
      }));
    }
  },
  (state, action) => {
    return updateResourceState(state, action, RESOURCE, ({ settings }) => ({
      settings: { ...settings, saving: false }
    }));
  }
);

export default accountReducer;
